function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-account_svg__prefix-icon-account-2{fill:none;stroke:#fff;stroke-width:.75px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1756",
  transform: "translate(-375 -303)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#e54910",
  "data-name": "Ellipse 73",
  transform: "translate(375 303)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1708",
  transform: "translate(-10.655 1191.4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M397.957-877.309a1.152 1.152 0 00.773 1.088l1.648.806a2.341 2.341 0 011.277 2.114v1.222h-10v-1.222a2.341 2.341 0 011.277-2.114l1.648-.806a1.16 1.16 0 00.782-1.088",
  className: "icon-account_svg__prefix-icon-account-2",
  "data-name": "Path 1168"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.561,
  cy: 3.164,
  className: "icon-account_svg__prefix-icon-account-2",
  "data-name": "Ellipse 71",
  rx: 2.561,
  ry: 3.164,
  transform: "translate(394.05 -883.36)"
})));

function SvgIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2);
}

export default SvgIconAccount;